export default __webpack_public_path__ + "static/media/ic-art-change-analytics.79a83c04.svg";